<template>
    <!--    <v-container>-->

    <!--        <v-row>-->
    <v-card tile elevation="0">
        <v-card-title class="px-4 text-center" :style="$vuetify.theme.dark ? 'background-color: #1e1f22' : 'background-color: white!important'">
            <v-col cols="12" class="pa-0">
                <v-btn-toggle tag="a" v-model="toggleFilters" mandatory dense class="period-switcher">
                    <v-btn
                        tag="a"
                        :width="buttonsWidth"
                        class="period-button"
                        color="tbGreen"
                        outlined
                        @click="showMarkets(null, false)"
                    >
                        {{ $t('event.allMarkets') }}
                    </v-btn>

                    <v-btn
                        tag="a"
                        :width="buttonsWidth"
                        class="period-button"
                        color="tbGreen"
                        outlined
                        @click="showMarkets($const.GAME_PERIOD_FT, false)"
                    >
                        {{ $t('event.marketFT') }}
                    </v-btn>

                    <v-btn
                        tag="a"
                        :width="buttonsWidth"
                        class="period-button"
                        color="tbGreen"
                        outlined
                        @click="showMarkets($const.GAME_PERIOD_1H, false)"
                    >
                        {{ $t('event.market1H') }}
                    </v-btn>

                    <v-btn
                        tag="a"
                        :width="buttonsWidth"
                        class="period-button"
                        color="tbGreen"
                        outlined
                        @click="showMarkets(null, true)"
                    >
                        {{ $t('event.corners') }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-card-title>
        <v-card-text class="pa-0" style="overflow-y: auto" :style="'height: ' + (tableHeight - 172) + 'px'">
            <!--                FT-->
            <AppEventStats
                v-show="isEmptyStats() === false && event.mId === $const.DBALL_MARKET_LIVE && $vuetify.breakpoint.width <= 940"
                :ref="setMarketRef"
            ></AppEventStats>
            <EventMarket1X2
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarket1X2_1'"
                :isAllExpanded="isExpanded"
                :isShow="!isEmpty(pricesWld) && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                v-show="!isEmpty(pricesWld) && (periodId === $const.GAME_PERIOD_FT || periodId === null)  && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarket1X2>
            <EventMarketDC
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketDC_1'"
                :isAllExpanded="isExpanded"
                :isShow="!isEmpty(pricesDc) && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                v-show="!isEmpty(pricesDc) && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketDC>
            <EventMarketOU
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketOU_1'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesOu.length && (periodId === $const.GAME_PERIOD_FT || periodId === null)) && isCornersMarketsOnly === false"
                v-show="pricesOu.length && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketOU>
            <EventMarketHDP
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketHDP_1'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesHdp.length && (periodId === $const.GAME_PERIOD_FT || periodId === null)) && isCornersMarketsOnly === false"
                v-show="pricesHdp.length && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketHDP>
            <EventMarketBTTS
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketBTTS_1'"
                :isAllExpanded="isExpanded"
                :isShow="!isEmpty(priceBTTS) && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                v-show="!isEmpty(priceBTTS) && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketBTTS>
            <EventMarketCS
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketCS_1'"
                :isAllExpanded="isExpanded"
                v-show="!isEmpty(pricesCs) && (periodId === $const.GAME_PERIOD_FT || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketCS>
            <EventMarketCornersOU
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketOU_1'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesCornersOu.length && (periodId === $const.GAME_PERIOD_FT || periodId === null || isCornersMarketsOnly === true))"
                v-show="pricesCornersOu.length && (periodId === $const.GAME_PERIOD_FT || periodId === null || isCornersMarketsOnly === true)"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketCornersOU>
            <EventMarketCornersHDP
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketHDP_1'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesCornersHdp.length && (periodId === $const.GAME_PERIOD_FT || periodId === null || isCornersMarketsOnly === true))"
                v-show="pricesCornersHdp.length && (periodId === $const.GAME_PERIOD_FT || periodId === null || isCornersMarketsOnly === true)"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketCornersHDP>
            <!--1H-->
            <EventMarket1X2
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarket1X2_2'"
                :isAllExpanded="isExpanded"
                :isShow="!isEmpty(pricesWld1h) && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                :period-id="$const.GAME_PERIOD_1H"
                v-show="!isEmpty(pricesWld1h) && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarket1X2>
            <EventMarketOU
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketOU_2'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesOu1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null)) && isCornersMarketsOnly === false"
                :period-id="$const.GAME_PERIOD_1H"
                v-show="pricesOu1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketOU>
            <EventMarketHDP
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketHDP_2'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesHdp1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null)) && isCornersMarketsOnly === false"
                :period-id="$const.GAME_PERIOD_1H"
                v-show="pricesHdp1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketHDP>
            <EventMarketBTTS
                :ref="setMarketRef"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketBTTS_2'"
                :isAllExpanded="isExpanded"
                :isShow="!isEmpty(pricesBTTS1h) && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                :period-id="$const.GAME_PERIOD_1H"
                v-show="!isEmpty(pricesBTTS1h) && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketBTTS>
            <EventMarketCS
                :ref="setMarketRef"
                :period-id="$const.GAME_PERIOD_1H"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketCS_2'"
                :isAllExpanded="isExpanded"
                :isShow="!isEmpty(pricesCs1h) && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                v-show="!isEmpty(pricesCs1h) && (periodId === $const.GAME_PERIOD_1H || periodId === null) && isCornersMarketsOnly === false"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketCS>
            <EventMarketCornersOU
                :ref="setMarketRef"
                :period-id="$const.GAME_PERIOD_1H"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketCornersOU_2'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesCornersOu1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null || isCornersMarketsOnly === true))"
                v-show="pricesCornersOu1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null || isCornersMarketsOnly === true)"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketCornersOU>
            <EventMarketCornersHDP
                :ref="setMarketRef"
                :period-id="$const.GAME_PERIOD_1H"
                :isShowAllMarketsToggle="firstVisibleMarketName === 'app-eventMarketCornersHDP_2'"
                :isAllExpanded="isExpanded"
                :isShow="!!(pricesCornersHdp1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null || isCornersMarketsOnly === true))"
                v-show="pricesCornersHdp1h.length && (periodId === $const.GAME_PERIOD_1H || periodId === null || isCornersMarketsOnly === true)"
                @toggleAllMarkets="toggleAllMarkets"
            ></EventMarketCornersHDP>
        </v-card-text>
        <BetDialog
            v-for="(dialogId, index) in betFeedData"
            :ref="utils.getBetDialogRef(index)"
            :width="440"
            :id="index"
            :key="index"
            module="EventModule"
            @cancel="cancel"
            :contentClass="'event-bet-dialog'"
            :idPrefix="'event-bet-dialog-'"
        ></BetDialog>
    </v-card>
    <!--        </v-row>-->
    <!--    </v-container>-->
</template>

<style scoped>
    .period-switcher.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
        border-color: #6aa84f !important;
    }
    .period-button {
        /*border: 1px solid #6aa84f !important;*/
        /*color: #6aa84f !important;*/

        font-size: 13px !important;
        letter-spacing: 0 !important;
        /*text-transform: none!important;*/
    }
    .theme--dark .period-button {
        background-color: #323338;
    }
    @media only screen and (max-width: 600px) {
        .period-button {
            font-size: 10px !important;
        }
    }

    @media only screen and (max-width: 320px) {
        .period-button {
            font-size: 8px !important;
        }
    }
</style>

<script>
    import EventMarket1X2 from './EventMarket1X2';
    import EventMarketDC from './EventMarketDC';
    import EventMarketCS from './EventMarketCS';
    import EventMarketOU from './EventMarketOU';
    import EventMarketHDP from './EventMarketHDP';
    import EventMarketCornersOU from './EventMarketCornersOU';
    import EventMarketCornersHDP from './EventMarketCornersHDP';
    import EventMarketBTTS from './EventMarketBTTS';
    import BetDialog from 'Pages/core/betDialog/BetDialog';
    import { eventMethods, eventGetters } from './eventCore';
    import utils from 'Helpers/utils';
    import AppEventStats from 'Pages/core/event/EventStats.vue';

    export default {
        name: 'app-eventMarketsTab',
        components: {
            AppEventStats,
            BetDialog,
            EventMarket1X2,
            EventMarketDC,
            EventMarketCS,
            EventMarketOU,
            EventMarketHDP,
            EventMarketCornersOU,
            EventMarketCornersHDP,
            EventMarketBTTS,
        },
        props: {
            tableHeight: {
                default: undefined,
                type: Number,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {
                isCornersMarketsOnly: false,
                periodId: null, //ALL Periods
                marketRefs: [],
                isExpanded: true,
                toggleFilters: 0,
            };
        },

        methods: {
            ...eventMethods(),
            isEmpty(value) {
                return _.isEmpty(value);
            },

            showMarkets(periodId, isCornersMarketsOnly = false) {
                this.isCornersMarketsOnly = isCornersMarketsOnly;
                this.periodId = periodId;
            },

            toggleAllMarkets() {
                this.isExpanded = !this.isExpanded;

                this.marketRefs.forEach((marketRef) => (marketRef.isExpanded = this.isExpanded));
            },
            setMarketRef(el) {
                if (el) {
                    this.marketRefs.push(el);
                }
            },
            resetMarkets() {
                this.marketRefs.forEach((marketRef) => (marketRef.odds = {})); //reset odds highlight
            },
            async cancel(data) {
                await utils.updateUserData(true);

                // data.success();
            },
            isEmptyStats: function () {
                return (
                    !this.eventStats.yellow_home &&
                    !this.eventStats.yellow_away &&
                    !this.eventStats.fouls_home &&
                    !this.eventStats.fouls_away &&
                    !this.eventStats.possession_time_home &&
                    !this.eventStats.possession_time_away &&
                    !this.eventStats.attacks_home &&
                    !this.eventStats.attacks_away &&
                    !this.eventStats.dangerous_attacks_home &&
                    !this.eventStats.dangerous_attacks_away &&
                    !this.eventStats.shots_home &&
                    !this.eventStats.shots_away &&
                    !this.eventStats.shots_on_target_home &&
                    !this.eventStats.shots_on_target_away &&
                    !this.eventStats.hit_woodwork_home &&
                    !this.eventStats.hit_woodwork_away &&
                    !this.eventStats.corners_home &&
                    !this.eventStats.corners_away
                );
            },
        },
        computed: {
            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },
            ...eventGetters(),
            event() {
                return this.$store.getters['EventModule/getEvent'];
            },
            pricesOu() {
                return this.$store.getters['EventModule/getOu'];
            },

            pricesOu1h() {
                return this.$store.getters['EventModule/getOu1h'];
            },
            pricesCornersOu() {
                return this.$store.getters['EventModule/getCornersOu'];
            },

            pricesCornersOu1h() {
                return this.$store.getters['EventModule/getCornersOu1h'];
            },

            pricesHdp() {
                return this.$store.getters['EventModule/getHdp'];
            },

            pricesHdp1h() {
                return this.$store.getters['EventModule/getHdp1h'];
            },

            pricesCornersHdp() {
                return this.$store.getters['EventModule/getCornersHdp'];
            },

            pricesCornersHdp1h() {
                return this.$store.getters['EventModule/getCornersHdp1h'];
            },

            pricesWld() {
                return this.$store.getters['EventModule/getWld'];
            },

            pricesWld1h() {
                return this.$store.getters['EventModule/getWld1h'];
            },

            priceBTTS() {
                return this.$store.getters['EventModule/getBtts'];
            },

            pricesBTTS1h() {
                return this.$store.getters['EventModule/getBtts1h'];
            },

            pricesDc() {
                return this.$store.getters['EventModule/getDc'];
            },

            pricesCs() {
                return this.$store.getters['EventModule/getCs'];
            },

            pricesCs1h() {
                return this.$store.getters['EventModule/getCs1h'];
            },

            betFeedData: {
                get() {
                    return this.$store.getters['EventModule/getBetFeedData'];
                },
                set(value) {
                    this.$store.commit('EventModule/setBetFeedData', value);
                },
            },

            firstVisibleMarketName() {
                const market = this.marketRefs.find((market) => market.isShow === true);

                // console.log(market ? (market.$options.name + '_' + market.$props.periodId): '');
                return market ? market.$options.name + '_' + market.$props.periodId : '';
            },

            buttonsWidth() {
                let width = this.$vuetify.breakpoint.width;

                if (width > 1315) {
                    width = 600;
                } else if (width <= 1315 && width > 940) {
                    width = width - width * 0.33;
                }

                if (width > 600) {
                    width = width - width*0.15
                }
                return (width - 16 - 16) / 4;
            }

        },
    };
</script>
